 /* eslint-disable */
import { AESEncryption, AESDecryption } from "./AesEncrypt";
import dev from '../config/dev';
import token from './TokenDecoder'
var serviceUrl = dev.apidomain;

export const CommonGet = (url, queryString)=>{

   
    return new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();
        if (queryString != null) {
            request.open("GET", serviceUrl + url +"?"+ AESEncryption(queryString));
        } else {
            
            request.open("GET", serviceUrl + url);
        }

        request.setRequestHeader("Content-type", "application/json; charset=utf-8");
        request.setRequestHeader('Access-Control-Allow-Methods', '*');
        request.setRequestHeader('Accept-Language', 'en-US');
        if(url!="/api/auth/login"){
            request.setRequestHeader('Authorization', `Bearer ${token.getToken()}`);
        }
        
        


        request.onload = () => {
            if (request.response === 'Token Time Exceed') {
                window.logout.logout();
            }
            else {
                if (request.status >= 200 && request.status < 300) {
                    resolve(JSON.parse(AESDecryption(request.response)));
                } else {
                    reject(request.statusText);
                }
            }
        };
        request.onerror = () => {
            reject(request.statusText);
        };
        request.send();
    });
};

export const CommonPost = (url, queryString, body) => {
   
    const encryptedResult = AESEncryption(JSON.stringify(body));
    return new Promise((resolve, reject) => {
        let request = new XMLHttpRequest();
        if (queryString != null) {
            request.open("POST", serviceUrl + url + "?" + AESEncryption(queryString));
        } else {
            request.open("POST", serviceUrl + url);
        }

        request.setRequestHeader("Content-type", "application/json; charset=utf-8");
        request.setRequestHeader('Access-Control-Allow-Methods', '*');
        request.setRequestHeader('Accept-Language', 'en-US');
        if(url!="/api/auth/login"){
            request.setRequestHeader('Authorization', `Bearer ${token.getToken()}`);
        }
        request.onload = () => {
            if (request.response === 'Token Time Exceed') {
                window.logout.logout();
            }
            else {
                if (request.status >= 200 && request.status < 300) {
                    resolve(JSON.parse(AESDecryption(request.response)));
                } else {
                    reject(request.statusText);
                }
            }
        };
        request.onerror = () => {
            reject(request.statusText);
        };
        request.send(encryptedResult);
    });
};



